import React from "react";
import { Form } from "antd";

const { Item } = Form;

const BuildFormLabel = ({
  label,
  isRequired,
  getFieldDecorator,
  inputType,
  inputComponent,
  uniqueName,
  errorMissing,
  errorInvalid,
  initialValue,
  translations
}) => {
  const shouldValidate = { type: inputType, message: errorInvalid };
  const shouldNotBeEmpty = { required: isRequired, message: errorMissing };
  const rules = inputType
    ? [shouldValidate, shouldValidate]
    : [shouldNotBeEmpty];
  if (label === 'title') {
    rules.push({ pattern: /^[^.]+$/, message: 'Full stops are not allowed' })
  }
  const translatedLabel = translations && translations[`nativetemplate.${label}`] ? translations[`nativetemplate.${label}`] : label;
  return (
    <Item label={translatedLabel}>
      {getFieldDecorator(uniqueName, {
        initialValue,
        rules
      })(inputComponent)}
      {/* <Tooltip title={description}>{children}</Tooltip> */}
    </Item>
  );
};

export default BuildFormLabel;



// WEBPACK FOOTER //
// ./src/components/NativeTemplates/Helpers/BuildFormLabel.js